module.exports = "/_next/static/images/37-1-ed811076987ae246b4c979eb19e09431.jpg";